// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var tabColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        icon: ic.heavy,
        text: tx.primary,
        disabled: {
            icon: ic.disabled,
            text: tx.disabled
        },
        hover: {
            background: bg.state.hover0,
            icon: ic.active
        },
        selected: {
            border: bd.active,
            icon: ic.active
        }
    };
};

//# sourceMappingURL=tabColors.js.map